import { Pipe, PipeTransform } from '@angular/core';
  
@Pipe({
    name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {
  transform(seconds: number): Date {
    return new Date(seconds * 1000);
  }
}